import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { NavigationActions, ParentNavigationItem } from '@next/core-lib/navigation';
import { WrapperSiteSidenavComponent } from '@next/core-lib/wrapper-site-sidenav';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [WrapperSiteSidenavComponent, RouterOutlet],
})
export class AppComponent {
  constructor(private readonly store: Store<RootState>) {
    this.store
      .select(AuthorizationSelectors.hasAtLeastAdministratorRole)
      .pipe()
      .subscribe((isAtleastAdmin) => {
        const menuItems: ParentNavigationItem[] = [
          {
            relativeUrl: '/cycle',
            label: 'app.cycles',
            icon: 'loop',
          },
          {
            relativeUrl: '/delivery',
            label: 'app.deliveries',
            icon: 'local_shipping',
          },
          {
            relativeUrl: '/performance',
            label: 'app.performance',
            icon: 'assessment',
          },
        ];

        if (isAtleastAdmin) {
          menuItems.push({
            relativeUrl: '/reference-value-sheet',
            label: 'app.reference-value-sheet',
            icon: 'assessment',
          });
        }

        menuItems.push({
          relativeUrl: '/settings',
          label: 'app.settings',
          icon: 'settings',
        });

        this.store.dispatch(NavigationActions.setNavigationItems({ navigationItems: menuItems }));
      });
  }
}
